module.exports = __webpack_public_path__ + "static/img/comper1.fbf550a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comper1.png
// module id = Tf32
// module chunks = 1